const sortOrder = ['democrat', 'republican', 'libertarian', 'green', 'independent', 'writein'];

export default function sortCandidates (candidates) {
  return candidates.sort((a, b) => {
    return b.votes - a.votes || sortOrder.indexOf(a.party) - sortOrder.indexOf(b.party) || a.ballot_last_name.localeCompare(b.ballot_last_name);
  });
}



// WEBPACK FOOTER //
// ./utils/sort-candidates.js